<div #splideTarget class="splide carousel">
  <div class="splide__track carousel-track ds-overflow-hidden">
    <ul class="splide__list carousel-slides ds-flex">
      <li
        *ngFor="let slide of slides"
        class="splide__slide carousel-slide ds-shrink-0"
      >
        <ng-template [ngTemplateOutlet]="slide.templateRef!"></ng-template>
      </li>
    </ul>
  </div>

  <div
    class="
      carousel-controls
      ds-mx-[32px] ds-max-w-[1320px] ds-pt-xl
      sm:!ds-pt-2xl
      md:!ds-mx-[72px] md:!ds-pt-3xl
      lg:!ds-mx-[80px]
      xl:!ds-mx-auto
    "
  >
    <ul
      class="
        splide__pagination
        carousel-pagination
        ds-flex ds-gap-xs ds-justify-center ds-items-center ds-h-2xl
      "
    ></ul>
    <div
      class="
        splide__arrows
        carousel-navigation
        ds-flex ds-justify-end ds-items-center ds-gap-xs ds-h-2xl
        -ds-mt-2xl
      "
    >
      <button
        class="
          splide__arrow splide__arrow--prev
          carousel-nav carousel-nav-prev
          ds-w-xl ds-h-xl
          disabled:ds-opacity-25
        "
      >
        <span
          class="
            ds-icons-arrow-left
            hover:before:!ds-bg-primary-blue
            active:before:!ds-bg-secondary-darkblue
          "
        ></span>
      </button>
      <button
        class="
          splide__arrow splide__arrow--next
          carousel-nav carousel-nav-next
          ds-w-xl ds-h-xl
          disabled:ds-opacity-25
        "
      >
        <span
          class="
            ds-icons-arrow-right
            hover:before:!ds-bg-primary-blue
            active:before:!ds-bg-secondary-darkblue
          "
        ></span>
      </button>
    </div>
  </div>
</div>
